



















import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../lib/util';
import AbpBase from '../lib/abpbase';
import wangeditor from 'wangeditor';
import appconst from '@/lib/appconst';
@Component
export default class showimg extends AbpBase {
  isHide = false;
  url = '';
  topposition = 0;

  larget(url): void {
    //showmodalimg
    this.url = url;
    this.isHide = true;
  }
  hideme(): void {
    this.isHide = false;
  }
}
